export default "__VITE_ASSET__Rx3Vy6SR__"